import { findRecursive, washDataArabic, washDataArabicAlign } from '@/mm/utils.js'

export function washData_productImgText(walkedNode) {
  const ProNode = findRecursive(walkedNode.list, (item) => item._type === 'button_text_1', 'list')
  if (ProNode) {
    if (!ProNode.actions[0].config['文字设计'].find((item) => item === 'self_textInput')) {
      ProNode.actions[0].config['文字设计'].unshift('self_textInput')
    }
    if (!ProNode.actions.find((item) => item === 'translate')) {
      ProNode.actions.push('translate')
    }
  }

  const ArabicRule = [
    {
      flag: 'product_title_flag',
      dataType: 'design',
      onlyEnglish: 'title_textAlign',
      englishTitleLeft: 'left',
      englishTitleRight: 'right'
    },
    {
      flag: 'product_content_title_flag',
      dataType: 'design',
      onlyEnglish: 'title_textAlign',
      englishTitleLeft: 'left',
      englishTitleRight: 'right'
    },
    {
      flag: 'product_content_flag',
      dataType: 'design',
      onlyEnglish: 'title_textAlign',
      englishTitleLeft: 'left',
      englishTitleRight: 'right'
    }
  ]

  ArabicRule.forEach((item) => {
    if (item.onlyEnglish) {
      washDataArabicAlign(
        walkedNode,
        item.flag,
        item.dataType,
        item.onlyEnglish,
        item.englishTitleLeft,
        item.englishTitleRight
      )
    } else {
      washDataArabic(
        walkedNode,
        item.flag,
        item.dataType,
        item.englishTitleLeft,
        item.englishTitleRight
      )
    }
  })
}
